<div class="menu__holder">
  <app-mobile-header-menu></app-mobile-header-menu>
  <router-outlet></router-outlet>

  <div class="menu__footer">
    <a class="menu__footer-link" [href]="appService.termsOfUseAddress">{{ 'external.useTerm' | translate }}</a>
    <div class="menu__footer-divider"></div>
    <a class="menu__footer-link" [href]="appService.privacyPolicyAddress">{{ 'external.privacyPolicy' | translate }}</a>
  </div>
</div>
